export default __webpack_public_path__ + "static/media/secret_pay_pro_b.b8ea0f62.svg";